export default "dist/images/block-feature-overlap-shape2.956d6fb.png";